
/* gui zone */
export const PROJECT_DETAILS_GUI_ZONE_ACTIVATE = 'PROJECT_DETAILS_GUI_ZONE_ACTIVATE';
export const PROJECT_DETAILS_GUI_ZONE_DEACTIVATE = 'PROJECT_DETAILS_GUI_ZONE_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/actions/gui-zone.ts